/** Endpoints of the Preference extension, added to the app's API. */
export const preferenceApiEndpoints = {
  preferenceAnalytics: "GET:/ext/preference/projects/:pk/analytics/",
};
